import "./styles.scss";

const LoadingStepSkeleton = () => {
	return (
		<div className="loading-step-section-skeleton">
			<div className="question-container" />
			<div className="form-container" />
		</div>
	);
};

export default LoadingStepSkeleton;
